export const FREE_LIMITS = {
  cases: 5,
  transcriptions: 10,
  templates: 3,
};

export const ESSENTIAL_LIMITS = {
  cases: 30,
  transcriptions: 50,
  templates: 20,
};

export const checkIfMaxCases = async (revcatUser: any, amplifyUser: any) => {
  // if they have premium entitlement, return false (havent hit limit)
  if (revcatUser.premium) return false;

  if (revcatUser.essential) {
    if (amplifyUser.currentCasesCreated >= ESSENTIAL_LIMITS.cases) {
      return true;
    } else {
      return false;
    }
  }

  if (amplifyUser.currentCasesCreated >= FREE_LIMITS.cases) {
    return true;
  } else {
    return false;
  }
};

export const checkIfMaxTranscriptions = async (
  revcatUser: any,
  amplifyUser: any,
) => {
  // if they have premium entitlement, return false (havent hit limit)
  if (revcatUser.premium) return false;

  if (revcatUser.essential) {
    if (
      amplifyUser.currentTranscriptionsCreated >=
      ESSENTIAL_LIMITS.transcriptions
    ) {
      return true;
    } else {
      return false;
    }
  }

  if (amplifyUser.currentTranscriptionsCreated >= FREE_LIMITS.transcriptions) {
    return true;
  } else {
    return false;
  }
};

export const checkIfMaxTemplates = async (
  revcatUser: any,
  amplifyUser: any,
) => {
  // if they have premium entitlement, return false (havent hit limit)
  if (revcatUser.premium) return false;

  if (revcatUser.essential) {
    if (amplifyUser.currentTemplatesUsed >= ESSENTIAL_LIMITS.templates) {
      return true;
    } else {
      return false;
    }
  }

  if (amplifyUser.currentTemplatesUsed >= FREE_LIMITS.templates) {
    return true;
  } else {
    return false;
  }
};
